import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule, LocationStrategy, HashLocationStrategy } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { TextMaskModule } from 'angular2-text-mask';
import { BootstrapModalModule } from 'ng2-bootstrap-modal';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { InputTrimModule } from 'ng2-trim-directive';
import { MyDatePickerModule } from 'mydatepicker';

import { AppComponent } from './app.component';
import { SDKBrowserModule } from './shared/sdk/index';
import { routing, appRoutingProviders } from './app.routing';

import { NavBarComponent } from './navbar.component';
import { FooterComponent } from './footer.component';
import { GlobalEventsManager } from './events-manager.component';

import { RegisterComponent } from './+register/registerPage/register.component';
import { VerifiedComponent } from './+register/verified/verified.component';

import { LoginComponent } from './+login/login.component';
import { ForgotPasswordComponent } from './+login/forgotPassword.component';
import { ResetPasswordComponent } from './+login/resetPassword.component';

import { HomeComponent } from './+home/home.component';
import { DashboardComponent } from './+dashboard/dashboard.component';
import { JompayOfferLetterComponent } from './+merchant_onboarding/jompay/jompay-offer-letter.component';
import { JompayDocumentsUploadComponent } from './+merchant_onboarding/jompay/jompay-documents-upload.component';

import { ServiceChoiceComponent } from './+merchant_onboarding/service_choice/service-choice.component';
import { Thank2Component } from './+merchant_onboarding/form/thank.component';
import { ConsentComponent } from './+merchant_onboarding/form/consent.component';
import { UpdateBizAccComponent } from './+merchant_onboarding/form/update-biz-acc.component';

import { M2UPayOfferLetterComponent } from './+merchant_onboarding/m2u_pay/m2u-pay-offer-letter.component';
import { PaymentNotificationTechnicalRequirementComponent } from './+merchant_onboarding/m2u_pay/payment-notification-tech-req.component';
import { PayeeCodeComponent } from './+merchant_onboarding/m2u_pay/payee-code.component';
import { ConfirmComponent } from './shared/app/components/confirm.component';
import { ImageModalComponent } from './shared/app/components/image-modal.component';
import { SubmissionDetailService } from "./shared/app/services/submission-detail.service";
import { CardsUatLiveComponent } from './+merchant_onboarding/credit_card/cards-uat-live.component';

import { POSOfferLetterComponent } from './+merchant_onboarding/pos/pos-offer-letter/pos-offer-letter.component';

import { HttpClientModule } from '@angular/common/http';

import { CookieService } from 'ngx-cookie-service';


@NgModule({
  declarations: [
    AppComponent,
    NavBarComponent,
    FooterComponent,
    LoginComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    HomeComponent,
    DashboardComponent,
    JompayOfferLetterComponent,
    JompayDocumentsUploadComponent,
    RegisterComponent,
    VerifiedComponent,
    ServiceChoiceComponent,
    Thank2Component,
    ConsentComponent,
    UpdateBizAccComponent,
    POSOfferLetterComponent,
    M2UPayOfferLetterComponent,
    PaymentNotificationTechnicalRequirementComponent,
    PayeeCodeComponent,
    ConfirmComponent,
    ImageModalComponent,
    CardsUatLiveComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    SDKBrowserModule.forRoot(),
    routing,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    TextMaskModule,
    NgIdleKeepaliveModule.forRoot(),
    BootstrapModalModule.forRoot({container:document.body}),
    InputTrimModule,
    MyDatePickerModule,
    HttpClientModule
  ],
  providers       : [ appRoutingProviders,SubmissionDetailService, GlobalEventsManager, CookieService,  {provide: LocationStrategy, useClass: HashLocationStrategy}],
  entryComponents : [ 
    AppComponent,
    ConfirmComponent,
    ImageModalComponent
   ],
  bootstrap       : [ AppComponent ]
})

export class AppModule {

}
